import AutocompleteOrganizers from '@/components/inputs/AutocompleteOrganizers.vue';
import EventAgreementLink from '@/components/global/event-agreements/EventAgreementLink.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DvTextarea from '@/packages/ui/components/inputs/DvTextarea.vue';
import DvSelect from '@/packages/ui/components/inputs/DvSelect.vue';
import DvCheckbox from '@/packages/ui/components/inputs/DvCheckbox.vue';
import DvPhoneField from '@/packages/ui/components/inputs/DvPhoneField.vue';
import AddressInput from '@/components/user-redesign/inputs/AddressInput.vue';
import DDatetimeField from '@/packages/ui/components/inputs/DateTimeField/DDatetimeField.vue';
import DvAutocompleteServer from '@/packages/ui/components/inputs/DvAutocompleteServer.vue';
import { rServices } from '@/plugins/api';
import DvSnilsField from '@/packages/ui/components/inputs/DvSnilsField.vue';
import { PER_PAGE } from '@/constants/pagination';

export const EVENT_ATTRIBUTES_TYPES = {
  address: 1,
  tel: 2,
  email: 3,
  text: 4,
  switch: 5,
  list: 6,
  organization: 7,
  file: 8,
  full_text: 9,
  agreement: 10,
  // |¯ Ниже постоянные (дефолтные), которых нет возможности кастомизировать
  birthday: 11,
  region: 12,
  municipality: 13,
  snils: 14,
  class: 15,
  // |_ Конец постоянных
};

export const EVENT_ATTRIBUTES_TYPES_CONST_TYPES = [
  EVENT_ATTRIBUTES_TYPES.birthday,
  EVENT_ATTRIBUTES_TYPES.region,
  EVENT_ATTRIBUTES_TYPES.municipality,
  EVENT_ATTRIBUTES_TYPES.snils,
];

export const EVENT_ATTRIBUTES_TYPES_TEXT = {
  [EVENT_ATTRIBUTES_TYPES.address]: 'Адрес',
  [EVENT_ATTRIBUTES_TYPES.tel]: 'Телефон',
  [EVENT_ATTRIBUTES_TYPES.email]: 'Email',
  [EVENT_ATTRIBUTES_TYPES.text]: 'Ввод строки',
  [EVENT_ATTRIBUTES_TYPES.full_text]: 'Ввод большого текста',
  [EVENT_ATTRIBUTES_TYPES.switch]: 'Флажок (Согласие)',
  [EVENT_ATTRIBUTES_TYPES.list]: 'Выбор значения из списка',
  [EVENT_ATTRIBUTES_TYPES.file]: 'Выбор значения из списка (файл)',
  [EVENT_ATTRIBUTES_TYPES.organization]: 'Организация',
  [EVENT_ATTRIBUTES_TYPES.agreement]: 'Согласие',
  [EVENT_ATTRIBUTES_TYPES.birthday]: 'Дата рождения',
  [EVENT_ATTRIBUTES_TYPES.region]: 'Регион',
  [EVENT_ATTRIBUTES_TYPES.municipality]: 'Муниципалитет',
  [EVENT_ATTRIBUTES_TYPES.snils]: 'СНИЛС',
  [EVENT_ATTRIBUTES_TYPES.class]: 'Класс',
};

export const HIDDEN_EVENT_ATTRIBUTES = [
  EVENT_ATTRIBUTES_TYPES.file,
  EVENT_ATTRIBUTES_TYPES.birthday,
  EVENT_ATTRIBUTES_TYPES.region,
  EVENT_ATTRIBUTES_TYPES.municipality,
  EVENT_ATTRIBUTES_TYPES.snils,
  EVENT_ATTRIBUTES_TYPES.class,
];

export const MERGED_EVENT_ATTRIBUTES = {
  [EVENT_ATTRIBUTES_TYPES.list]: (data) => !data.options?.length ? EVENT_ATTRIBUTES_TYPES.file : EVENT_ATTRIBUTES_TYPES.list,
};

export const EVENT_ATTRIBUTES_KEYS = Object.fromEntries(
  Object.entries(EVENT_ATTRIBUTES_TYPES)
    .map(
      ([key, value]) => HIDDEN_EVENT_ATTRIBUTES.includes(value) ? null : [key, value],
    )
    .filter(Boolean),
);

export const EVENT_ATTRIBUTES_TYPES_COMPONENTS = {
  [EVENT_ATTRIBUTES_TYPES.address]: {
    is: AddressInput,
    rules: '',
    attrs: () => ({
      placeholder: 'Введите адрес',
      'return-object': false,
      clearable: true,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.tel]: {
    is: DvPhoneField,
    rules: 'phone',
    attrs: () => ({
      clearable: true,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.email]: {
    is: DvTextField,
    rules: 'email|max:256',
    attrs: () => ({
      type: 'email',
      placeholder: 'Введите Email',
      clearable: true,
      counter: 256,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.text]: {
    is: DvTextField,
    rules: 'max:2048',
    attrs: () => ({
      placeholder: 'Введите значение',
      clearable: true,
      counter: 2048,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.full_text]: {
    is: DvTextarea,
    rules: 'max:10000',
    attrs: () => ({
      outlined: true,
      placeholder: 'Введите значение',
      rows: 4,
      maxCounterValue: 10000,
      topLabel: false,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.switch]: {
    is: DvCheckbox,
    rules: '',
    attrs: ({ is_required }) => ({
      keyValue: 'value',
      keyText: 'label',
      item: is_required,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.list]: {
    is: DvSelect,
    rules: '',
    attrs: ({ is_many_options, options }) => ({
      clearable: true,
      placeholder: 'Выберите значение из списка',
      multiple: is_many_options,
      items: options,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.file]: {
    is: DvSelect,
    rules: '',
    attrs: ({ is_many_options, options }) => ({
      placeholder: 'Выберите значение из списка',
      multiple: is_many_options,
      items: options,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.organization]: {
    is: AutocompleteOrganizers,
    rules: '',
    attrs: () => ({
      placeholder: 'Выберите организатора',
      'background-color': 'redesignControlsBackground',
      outlined: true,
      dense: true,
      clearable: true,
      chips: false,
      'small-chips': false,
      userRegion: true,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.agreement]: {
    is: EventAgreementLink,
    rules: '',
    attrs: ({ title, document }) => ({
      title,
      file: document,
      'hide-details': false,
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.birthday]: {
    is: DDatetimeField,
    rules: '',
    attrs: () => ({
      onlyDate: true,
      tooltip: {
        activatorClass: 'd-block full-width',
      },
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.region]: {
    is: DvAutocompleteServer,
    rules: '',
    attrs: () => ({
      method: ({ params }) => rServices.directories.getRegions({
        params: {
          ...params,
          'per-page': PER_PAGE.infinity,
        },
      }).then(({ response, error }) => ({
        items: response?.data?.data || [],
        response,
        error,
      })),
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.municipality]: {
    is: DvAutocompleteServer,
    rules: '',
    attrs: ({ region_id }) => ({
      method: ({ params }) => rServices.directories.getMunsCached({
        params: {
          ...params,
          'search[region_id]': region_id,
          ...region_id ? {
            'per-page': PER_PAGE.infinity,
          } : {},
        },
      }).then(({ response, error }) => ({
        items: response?.data?.data || [],
        response,
        error,
      })),
    }),
  },
  [EVENT_ATTRIBUTES_TYPES.snils]: {
    is: DvSnilsField,
    rules: 'snils',
    attrs: () => ({}),
  },
  [EVENT_ATTRIBUTES_TYPES.class]: {
    is: DvSelect,
    rules: '',
    attrs: ({ options }) => ({
      clearable: true,
      placeholder: 'Выберите класс',
      items: (options?.variants || options).map((name) => ({ name, id: name.replace(/\D/g, '') })),
    }),
  },
};
